module.exports = __webpack_public_path__ + "static/media/video.40ba618b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/video.mp4
// module id = 201
// module chunks = 0